export default "__VITE_ASSET__AsHNVVn_Y92mmWEtoBC9VA__";